import { Constants } from '../helpers/constants';
import { Utils } from '../helpers/utils';
import { Dmenu } from './dmenu';
import { PizzaConfig } from './pizza-config';

export class Company {
	id: number;
	name: string;

	open_hours: string;
	delivery_hours: string;

	// json string
	/*
		{
			digital_menu: {
				disclaimers: string[]
			}
		}
	*/
	additional_info: string;

	delivery_eta: number;

	whatsapp_number: string;
	phone: string;

	dmenus: Dmenu[];

	// payment methods not allowed, separated by comma.
	// for example: 'credit_card,debit_card,transfer'
	payment_restriction: string;

	pix_info: string; /* Example: "{\"key\":\"myemail@email.com\",\"name\":\"My Full Name\",\"city\":\"My City\",\"cep\":\"My CEP Code\"}" */
	pizza_config: string;
	parsedPizzaConfig: PizzaConfig;

	oo_pinged_at: string;
	created_at: string;
	updated_at: string;

	// set by our front end app
	prettyName: string;
	deliveryStatus: 'closed'|'open'|'closing'|'opening';
	currentShift: {opensAt: string, closesAt: string};
	parsedDeliveryHours: {
		[day_of_week: string]: string[]
	};
	nextDeliveryShift: {
		[day_of_week: string]: string
	};

	parsedOpenHours: {
		[day_of_week: string]: string[]
	};

	static setAdditionalData(company: Company) {
		let aux = company.name.split('-');
		for(let i = 0; i < aux.length; i++) {
			aux[i] = aux[i].charAt(0).toUpperCase() + aux[i].slice(1);
		}
		company.prettyName = aux.join(' ');

		if(company.open_hours) {
			company.parsedOpenHours = JSON.parse(company.open_hours);
		}
		
		if(company.delivery_hours){
			company.parsedDeliveryHours = JSON.parse(company.delivery_hours);
			company.deliveryStatus = Company.isDeliveryOpen(company);
			company.nextDeliveryShift = Company.nextDeliveryShift(company);
		}

		if(company.delivery_eta < 0) {
			company.deliveryStatus = 'closed';
		}

		if(company.pizza_config) {
			try {
				company.parsedPizzaConfig = new PizzaConfig(JSON.parse(company.pizza_config));
			} catch (e) {
				company.parsedPizzaConfig = null;
			}
		}
	}

	static isDeliveryOpen(company: Company): 'closed'|'open'|'closing'|'opening' {
		if(!company.delivery_hours)
			return 'closed';

		if(!company.parsedDeliveryHours)
			Company.setAdditionalData(company);

		let aux = Utils.isOnSchedule(company.parsedDeliveryHours, 30, 40);
		company.currentShift = aux.currentShift;
		
		// if company hasn't pinged for over 10 minutes, mark delivery as closed
		if(company.oo_pinged_at && (new Date().getTime() - new Date(company.oo_pinged_at).getTime() > 1000*60*10)) {
			return 'closed';
		} else {
			return aux.status;
		}
	}

	static nextDeliveryShift(company: Company, now: Date = new Date(), retries = 0): {[day_of_week: string]: string} {
		if(!company.delivery_hours)
			return null;

		const daysOfWeek = Constants.daysOfWeek;

		const today = daysOfWeek[now.getDay()];

		if(!company.parsedDeliveryHours[today] && retries < 7) {
			now.setDate(now.getDate() + 1);
			now.setHours(0, 0, 0);
			return Company.nextDeliveryShift(company, now, retries + 1);
		}

		let res = {};
		let time: number = now.getHours() + now.getMinutes()/60;
		const shifts: string[] = company.parsedDeliveryHours[today];
		for(let shift of shifts) {
			let openStr: string = shift.split('-')[0];

			let open_h = openStr.split(':')[0];
			let open_m = openStr.indexOf(':') > -1 ? openStr.split(':')[1] : 0;

			let openAt = Number(open_h) + Number(open_m)/60;

			if(time < openAt) {
				res[today] = shift;
				return res;
			}
		}

		now.setHours(0);
		now.setMinutes(0);
		now.setDate(now.getDate() + 1);
		return Company.nextDeliveryShift(company, now, retries + 1);
	}

	static statusPtbr(status: 'closed'|'closing'|'opening'|'open') {
		switch(status) {
			case 'closed':
				return 'fechado';
			case 'closing':
				return 'fechando';
			case 'opening':
				return 'abrindo';
			case 'open':
				return 'aberto';
		}
	}

	static getDigitalMenuDisclaimers(company: Company): string[] {
		if(!company || !company.additional_info) {
			return null;
		}

		let json = JSON.parse(company.additional_info);

		if(json["digital_menu"] && json["digital_menu"]["disclaimers"]) {
			return json["digital_menu"]["disclaimers"];
		} else {
			return null;
		}
	}
}